// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3QVGK","label":"LabeledBox_label__3m03I"};